import React from 'react';
import { IconButton, styled } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(2),
  right: theme.spacing(2),
}));

interface DeveloperButtonProps {
  onClick: () => void;
}

export const DeveloperButton = ({ onClick }: DeveloperButtonProps) => (
  <StyledIconButton
    onClick={onClick}
    aria-label="Developer Tools"
    size="large"
    data-testid="developer-tools-button"
  >
    <SettingsIcon />
  </StyledIconButton>
);
